import IntroduceYourself from './components/IntroduceYourself';
import Spinner from '../../../../../../components/Spinner/';

import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const SelfIntro = gql`
    query SelfIntro {
      getSelfIntro {
				id
        videoToken
				otherVideoTokens
      }
    }
`;

const SubmitSelfIntroVideo = gql`
    mutation SetVideoAnswer($videoToken: String!) {
      setVideoAnswer(input: {
        videoToken: $videoToken
      }) {
        id
				videoToken
      }
    }
`;

const RemoveSelfIntroVideo = gql`
    mutation RemoveSelfIntroVideo($videoRecordId: Int!) {
      deleteVideoAnswer(input: {
        videoRecordId: $videoRecordId
      }) {
        id
				videoToken
      }
    }
`;

export default (store) => ({
    path: 'self-intro',
    component: compose(
        graphql(SelfIntro, {
            name: 'SelfIntro',
            options: {
                fetchPolicy: 'network-only'
            },
        }),
        graphql(SubmitSelfIntroVideo, {
            name: 'SubmitSelfIntroVideo',
            options: {
                fetchPolicy: 'network-only'
            },
        }),
        graphql(RemoveSelfIntroVideo, {
            name: 'RemoveSelfIntroVideo',
            options: {
                fetchPolicy: 'network-only'
            },
        }),
    )((props) => {
        if (props.SelfIntro.loading === false) {
            return <IntroduceYourself {...props} />;
        }
        return <Spinner />;
    }),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/SelfIntro/index.js